
import { RESEND_CONFIRMATION_EMAIL } from '~/api/apolloCustomerMutations';

export default {
  name: 'AuthMessage',
  props: {
    type: {
      type: String,
      default: 'info',
    },
    content: {
      type: String,
      default: '',
    },
    code: {
      type: String,
      default: '',
    },
    isPage: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isCaptchaShown: false,
    };
  },
  computed: {
    messageType() {
      if (this.code === 'SUCCESS_SIGNUP' || this.code === 'SUCCESS_RESEND_CONFIRMATION') {
        return 'info';
      }
      return this.type;
    },
    isContentExist() {
      const validCodes = ['INVALID_EMAIL_OR_PASSWORD', 'SUCCESS_RESETPW', 'EMAIL_NOT_CONFIRMED', 'EMAIL_EXISTS'];
      return validCodes.includes(this.code);
    },
    computedContent() {
      const contentMap = {
        INVALID_EMAIL_OR_PASSWORD: {
          prefix: 'To reset your password,',
          action: () => { this.goToForgotPassword(); },
        },
        EMAIL_NOT_CONFIRMED: {
          prefix: 'To resend the confirmation email please,',
          action: () => { this.isCaptchaShown = true; },
        },
        EMAIL_EXISTS: {
          prefix: 'To reset your password,',
          action: () => { this.goToForgotPassword(); },
        },
        SUCCESS_RESETPW: {
          prefix: 'To resend the email,',
          action: () => { this.goToForgotPassword(); },
        },
      };

      const defaultContent = { prefix: '', link: '', suffix: '' };

      return contentMap[this.code] || defaultContent;
    },
    messageIcon() {
      return this.type === 'success' ? 'IconCheckmarkGreen-48x48' : 'IconAlertRed-48x48';
    },
  },
  methods: {
    handleClick(event) {
      if (event.target.id === 'second-confirmation-click-here') {
        this.isCaptchaShown = true;
      }
    },
    goToForgotPassword() {
      if (!this.isPage) {
        this.$emit('change-popup-type', 'AccountForgotPassword');
      } else {
        this.$router.push('/customer/account/forgotpassword');
        this.$emit('reset-messages');
      }
    },
    async resendConfirmationEmail() {
      const token = this.$refs.recaptcha.getResponse();
      const email = this.content.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/)?.[0];
      try {
        const { customer: { resendConfirmation } } = await this.$graphql.default
          .request(RESEND_CONFIRMATION_EMAIL, { email, token }) || {};

        if (resendConfirmation?.message) {
          this.$emit('add-message', {
            type: resendConfirmation?.success ? 'success' : 'error',
            code: resendConfirmation?.code,
            content: `${resendConfirmation?.message}`,
          });
        }
        this.isCaptchaShown = false;
      } catch (e) {
        console.error(e);
      }
    },
  },
};
